import './App.css';
import "./resources/css-custom-24-cols-grid/grid.css"
import "./resources/js-simple-loader/loader.css"
import "./resources/js-validation-notification/validation.style.css"
import "react-big-calendar/lib/css/react-big-calendar.css";
import {useEffect, useRef, useState} from "react"
import {Service} from './service';
import {SimpleSection} from './components/simpleSection';
import target from "./icons/icon_target.svg"
import Select from './components/select/select';
import {Title} from './components/title';
import {Calendario} from './components/calendar';
import {SimpleBadge} from './components/simpleBadge';
import {Modal} from './components/modal';
import {Button} from './components/button';
import {Input} from './components/input';
import {Resultado} from './components/resultado';
import {SelectCard} from './components/card';
import {Erro} from './components/erro';
import MapComponent from './components/map';
import StepMarker from './components/stepMarker/index.tsx';
import {faClock, faFlagCheckered, faIdCard, faMapLocationDot, faVolleyball} from "@fortawesome/free-solid-svg-icons";

function App() {

    const [operation, setOperation] = useState(0); // 0 => início/unidade; 1 => modalidade; 2 => calendário; 3 => cadastro; 4=> obrigado;
    // const [data, setData] = useState({
    //     nome: 'Rodrigo Priolo',
    //     email: 'priolo@smartside.com.br',
    //     cpf: '33359250842',
    //     telefone: '11999999999',
    // })
    const [data, setData] = useState({});
    const [branch, setBranch] = useState("");
    const [unidadeNome, setUnidadeNome] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [closestLocation, setClosestLocation] = useState("");
    const [hasPermission, setHasPermission] = useState(false);
    const [source, setSource] = useState("");
    //const [isMobile, setIsMobile] = useState(true);
    const app = useRef()

    window.addEventListener('resize', function () {
        setIsMobile(window.innerWidth < 768);
        //setIsMobile(true);
    });

    useEffect(() => {
        if (operation !== 5) {
            let test = Service.userHasSubmitted();
            if (test && test.email === data?.email && test.modalidade === data?.modalidade) {
                setData(test);
                setOperation(5);
            }
        }
        if (data.classificacao === "Minha localização") {
            RequirePermission();
        }
    }, [data]);

    useEffect(() => {
        if (branch !== "") {
            Service.setBranch(branch)
            if (data?.unidade) {
                let unidade = Service.getUnidades().filter(unidade => unidade.api === data.unidade)[0];
                setUnidadeNome(unidade.nome);
            }
        }
    }, [branch]);

    useEffect(() => {
        if (app.current) {
            if (isMobile) {
                app.current.style.minHeight = (window.innerHeight - 700) + "px";
            } else {
                app.current.removeAttribute('style')
            }
        }
    }, [isMobile]);

    useEffect(() => {
        if (operation >= 5) {
            if (app.current) {
                app.current.removeAttribute('style')
            }
        }
    }, [operation])

    useEffect(() => {
        if (closestLocation !== "" && hasPermission) {
            setBranch(closestLocation.api);
            setData({...data, classificacao: closestLocation.regiao, unidade: closestLocation.api});
            setOperation(isMobile ? 1 : 2);
        }
    }, [closestLocation]);

    const AddUser = async () => {
        let result = await Service.addUser(data);
        if (!result) {
            setOperation(6);
            return false;
        }
        window.dataLayer = window.dataLayer || [];
        if (source === "tiktok") {
            window.dataLayer.push({event: "sign_up_agendamento_tiktok", data: data});
        } else {
            window.dataLayer.push({event: "sign_up_agendamento", data: data});
        }
        setOperation(5);
    }

    const RequirePermission = () => {
        navigator.geolocation.getCurrentPosition((position) => {
            setHasPermission(true);
        });
    }

    const SendToGTM = (e) => {
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "generate_lead_calendar",
            data: data
        });
        return false;
    }

    const Preselect = () => {
        setTimeout(function () {
            let params = Service.getParams();
            if (params) {
                setData({...data, classificacao: params[0], unidade: params[1]})
                setBranch(params[1]);
                let unidade = Service.getUnidades().filter(unidade => unidade.api === params[1])[0];
                setClosestLocation(unidade);
                setOperation(2);
            }

        }, 1000);
    }

    const Initialize = () => {
        const urlSource = Service.getSource();
        if (!!urlSource) {
            const hasSource = source !== "";
            if (!hasSource && urlSource === "tiktok") {
                setSource(urlSource);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "agendamento_tiktok_view",
                    data: data
                });
            }
        }
    }

    useEffect(() => {
        Preselect();
        setTimeout(Preselect, 300)
    }, [])

    useEffect(() => {
        Initialize();
    }, []);


    return (
        <div className="App" ref={app}>
            <div className='app-hero'>
                <div className='container'>
                    <h1>Agende uma Aula Gratuita</h1>
                </div>
            </div>
            <div className={`app-content operation-${operation}`}>
                <div className='container'>
                    <div id="step-markers">
                        <StepMarker callback={() => setOperation(1)} text="Unidade" completed={operation > 0}
                                    icon={faMapLocationDot} current={operation <= 1}/>
                        <StepMarker callback={operation >= 2 ? () => setOperation(2) : null} text="Modalidade"
                                    completed={operation > 2} icon={faVolleyball} current={operation === 2}/>
                        <StepMarker callback={operation >= 3 ? () => setOperation(3) : null} text="Data"
                                    completed={operation > 3} icon={faClock} current={operation === 3}/>
                        <StepMarker callback={operation >= 4 ? () => setOperation(4) : null} text="Cadastro"
                                    completed={operation > 4} icon={faIdCard} current={operation === 4}/>
                        <StepMarker text="Só colar!" completed={operation === 5} icon={faFlagCheckered}
                                    current={operation === 5}/>
                    </div>
                </div>
                {((operation < 5)) && <>
                    <div className='container h-100'>

                        {isMobile && operation > 1 &&
                            <button onClick={() => setOperation(operation - 1)} id='go-back'><i
                                className='fas fa-chevron-left'></i></button>}

                        {(!isMobile || (isMobile && operation < 2)) && <div className='row d-flex'>
                            <div className='col-24 col-sm-24 col-md-9 col-lg-8'>
                                <div>
                                    <SimpleSection>
                                        {/*<img src={calendar} className="icon" alt="icone-calendario" />*/}
                                        <Title text={(isMobile ? "Agende uma aula gratuita" : "Onde quer treinar?")}/>
                                        <Select placeholder='Selecione a Região' name="classificacao"
                                                value={data?.classificacao} onChange={(e, t) => {
                                            setData({...data, classificacao: e});
                                            setOperation(operation < 1 ? 1 : operation);
                                            setBranch(e);
                                        }} options={[{
                                            image: target,
                                            value: "Minha localização",
                                            text: "Minha localização"
                                        }, {
                                            value: "São Paulo Capital",
                                            text: "São Paulo Capital"
                                        }, {
                                            value: "Grande São Paulo",
                                            text: "Grande São Paulo"
                                        }, {value: "Interior de São Paulo", text: "Interior de São Paulo"}]}/>
                                        {data?.classificacao && <SimpleBadge text={data?.classificacao}/>}
                                        <br/>
                                        {data?.classificacao &&
                                            <Select placeholder='Escolha a Unidade' name="unidade" value={data?.unidade}
                                                    onChange={(e, t) => {
                                                        setData({...data, unidade: e});
                                                        if (!isMobile) {
                                                            setOperation(operation < 2 ? 2 : operation)
                                                        }
                                                        ;setBranch(e);
                                                    }}
                                                    options={Service.getUnidades().filter(unidade => unidade.regiao === data.classificacao).map(unidade => {
                                                        return {value: unidade.api, text: unidade.nome}
                                                    })}/>}
                                        {unidadeNome !== "" && <SimpleBadge text={unidadeNome}/>}
                                        <br/>
                                        <br/>
                                    </SimpleSection>
                                </div>
                            </div>
                            <div className='col-24 col-sm-24 col-md-1 col-lg-2'></div>
                            <div className='col-24 col-sm-24 col-md-14 col-lg-14' id="map">
                                {Service.getUnidades() !== undefined && Service.getUnidades().length > 0 &&
                                    <MapComponent location={data.unidade} setClosestLocation={setClosestLocation}
                                                  apiKey={Service.googleMapsAPIKey}
                                                  establishmentAddresses={Service.getUnidades()}/>}
                                <div><br/><br/><br/></div>
                            </div>
                        </div>}

                        {operation >= 2 && typeof data.unidade !== "undefined" && (!isMobile || (isMobile && operation < 3)) &&
                            <div className='row d-flex'>
                                <div className='col-24'>
                                    <SimpleSection>
                                        {/*<img src={tenis} className="icon" alt="icone-raquete" />*/}
                                        <Title text={"Escolha sua modalidade"}/>
                                        <div className='row'>
                                            {Service.getModalides().map((modalidade, index) => {
                                                if (isMobile) {
                                                    return <div key={index} className='col-24'>
                                                        <SimpleBadge selected={data?.modalidade === modalidade.nome}
                                                                     text={modalidade.nome} onClick={() => setData({
                                                            ...data,
                                                            modalidade: modalidade.nome
                                                        })}/>
                                                    </div>
                                                }
                                                return <div className='col-xs-24 col-sm-12 col-md-8' key={index}>
                                                    <SelectCard image={modalidade.image} text={modalidade.nome}
                                                                selected={data?.modalidade === modalidade.nome}
                                                                onClick={() => {
                                                                    setData({...data, modalidade: modalidade.nome});
                                                                    setOperation(3);
                                                                }}
                                                                button={data?.modalidade === modalidade.nome ? "Selecionado" : "Selecionar"}/>
                                                    <br/>
                                                </div>
                                            })}
                                        </div>
                                        <br/>
                                        <br/>
                                    </SimpleSection>
                                </div>
                            </div>}

                        {operation >= 3 && <div className='row d-flex h-100'>
                            <div className='col-24'>
                                <br/>
                                <Calendario isMobile={isMobile} unidade={data?.unidade} modalidade={data?.modalidade}
                                            onReturn={(calendarData) => {
                                                setData({...data, aulaExperimental: calendarData});
                                                if (!isMobile) {
                                                    setOperation(4)
                                                }
                                            }}/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                        </div>}

                    </div>

                    <Modal open={(operation === 4)} onClose={() => {
                        setOperation(operation - 1)
                    }}>
                        <form onSubmit={SendToGTM}>
                            <input type="hidden" name="classificacao" value={data?.classificacao}/>
                            <input type="hidden" name="unidade" value={data?.unidade}/>
                            <input type="hidden" name="modalidade" value={data?.modalidade}/>

                            <img src='http://posto011.com.br/wp-content/uploads/2022/12/android-chrome-144x144-1.png'
                                 className='img-responsive img-fluid pull-left float-left modal-image'/>
                            <Title text={"Bora confirmar sua aula?"}/>
                            <Input placeholder={"Nome completo *"} value={data?.nome}
                                   onChange={(evt) => setData({...data, nome: evt.target.value})}/>
                            <Input placeholder={"CPF *"} value={data?.cpf}
                                   onChange={(evt) => setData({...data, cpf: evt.target.value})}/>
                            <Input placeholder={"Telefone *"} value={data?.telefone}
                                   onChange={(evt) => setData({...data, telefone: evt.target.value})}/>
                            <Input placeholder={"E-mail *"} value={data?.email}
                                   onChange={(evt) => setData({...data, email: evt.target.value})} type="email"/>
                            É cliente Wellhub (Gympass)?*
                            <div style={{marginTop: "10px", marginBottom: "10px"}}>
                                <input type="radio" id="no" name="has_wellhub" value="no" onChange={(evt) => setData({...data, hasWellhub: evt.target.value})} />
                                <label htmlFor="no" style={{paddingLeft: "4px", marginRight: "20px"}}>Não</label>
                                <input type="radio" id="yes" name="has_wellhub" value="yes" onChange={(evt) => setData({...data, hasWellhub: evt.target.value})} />
                                <label htmlFor="yes" style={{paddingLeft: "4px"}}>Sim</label>
                            </div>
                            {data?.hasWellhub === "yes" &&
                            <Input placeholder={"Insira o seu ID Wellhub aqui"} value={data?.tokenGympass} style={{marginTop: "20px"}}
                                   onChange={(evt) => setData({...data, tokenGympass: evt.target.value})} />}
                            <Button text='Continuar' onClick={AddUser}/>
                        </form>
                    </Modal>

                </>}

                {operation === 5 && <Resultado isMobile={isMobile} data={data}/>}
                {operation === 6 && <Erro isMobile={isMobile}/>}

            </div>
            {operation < 5 && <div className={`footer-hero operation-${operation} d-none d-xs-block p-4`}>
                <Button text="Continuar"
                        enabled={(operation === 1 && data.hasOwnProperty('classificacao') && data.hasOwnProperty('unidade')) || (operation === 2 && data.hasOwnProperty('modalidade')) || (operation === 3 && data.hasOwnProperty('aulaExperimental'))}
                        onClick={() => {
                            window.scrollTo(0, 0);
                            setOperation(operation + 1)
                        }}/>
            </div>}
        </div>
    );
}

export default App;
